import { axiosV2 } from 'interceptors/axios';
import { decryptResponse } from 'utils/token';

export type PartnerIdentifierByCif = {
  _id: string;
  cif: string;
};

type GetPartnerIdentifiersByCifsProps = {
  societyId: string;
  cifs: string[];
};

export const getPartnerIdentifiersByCifs = async ({
  societyId,
  cifs,
}: GetPartnerIdentifiersByCifsProps): Promise<PartnerIdentifierByCif[]> => {
  if (!societyId || !cifs?.length) {
    return [];
  }

  const { data } = await axiosV2.post('/partners/identifiers-by-cif', {
    societyId,
    cifs,
  });

  const decodedData = (await decryptResponse(data)) as PartnerIdentifierByCif[];

  return Array.isArray(decodedData) ? decodedData : [];
};
